import "#vendor/before-after.js/before-after.js";

// TODO: Hook event sessions
class BeforeAndAfterBehavior extends Sparkle.PageBuilder.Components.Behavior {
  constructor() {
    super(...arguments);
    this.onRender = this.onRender.bind(this);
    this.initialize = this.initialize.bind(this);
  }

  onRender() {
    return this.initialize();
  }

  initialize() {
    return Sparkle.Codeload.import(window.SparkleConfig.assetPaths.beforeAfter).done(() =>
      this.el.find(".before-and-after-container").addClass("initialized").beforeAfter({
        resizableImageSelector: ".resize .image",
      }),
    );
  }
}
BeforeAndAfterBehavior.register("before_and_after");
